import React from 'react'
import { NavLink } from 'react-router-dom'
import CookieConsent from '../CookieConsent'

const Footer = () => {
  return (
    <div style={{background: '#333', paddingTop: '20px', padding: "20px", overflow: "hidden"}}>
<footer className="site_footer footer_layout_4 section_decoration mt-5 " >
  
  <div className="container" style={{padding: '40px'}}>
    
    <div className="row justify-content-lg-between">
      <div className="col-lg-3 col-md-6 col-sm-6">
        <h3 className="footer_info_title ">Quick Links</h3>
        <ul className="iconlist_block unordered_list_block mb-0">
          <li>           
           <NavLink to="/about-us">
           <span className="iconlist_text">About Us</span></NavLink>
         </li>
         <li>           
            <NavLink to="/become-a-member">
            <span className="iconlist_text">Become a Member</span></NavLink>
          </li>
          {/* <li>
            <a href="#!">
              <span className="iconlist_text">Industry News</span>
            </a>
          </li> */}
          <li>
          <NavLink to="/workshop-webinars">
              <span className="iconlist_text">Workshops & Webinars</span>
            </NavLink>
          </li>
           <li>
          <NavLink to="/blogs">
              <span className="iconlist_text">Blogs</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/news">
              <span className="iconlist_text">News</span>
            </NavLink>
          </li>
          {/* <li>
          <NavLink to="/webinar-registration">
              <span className="iconlist_text">Webinar Registration</span>
            </NavLink>
          </li> */}
          {/* <li>
          <a href="#!">
              <span className="iconlist_text">Case Studies</span>
            </a>
          </li> */}
         
        </ul>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6">
        <h3 className="footer_info_title">Useful Links</h3>
        <ul className="iconlist_block unordered_list_block mb-0">
        
          <li>
            <NavLink to="privacy-policy">
              <span className="iconlist_text">Privacy Policy</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/terms-and-conditions">
              <span className="iconlist_text">Terms and Conditions</span>
            </NavLink>
          </li>   
        </ul>
      </div>

      <div className="col-lg-4 col-md-6 col-sm-6">
        <h3 className="footer_info_title">Contact Info</h3>
        <ul className="iconlist_block unordered_list_block mb-0">
          {/* <li>
            <a href="#!">
              <span className="iconlist_text"> <i className="fa-solid fa-map-marker-alt" style={{background: "#fff", borderRadius: "50%", padding: '10px', marginRight: '10px'  }} />
             
              85 Marlyon Road, London IG6 3XW </span>
            </a>
          </li> */}
          <li>
            <a href="mailto:info@msbassociationuk.org">
              <span className="iconlist_text"> <i className="fa-solid fa-envelope" style={{background: "#fff", borderRadius: "50%", padding: '10px', marginRight: '10px'  }} />
              info@msbassociationuk.org </span>
            </a>
          </li>

          <li>
                <a href="tel:442045873789">
                  <span className="iconlist_icon">
                  <i className="fa-solid fa-phone" style={{background: "#fff", borderRadius: "50%", padding: '10px', marginRight: '0px'  }} />
                  </span>
                  <span className="iconlist_text">+44 20 4587 3789</span>
                </a>
              </li>
      
        </ul>
      </div>
    </div>
  </div>
  <div className="footer_bottom">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-12 text-center" >
          <p className="text-white mb-0">
          Copyright © 2025 <a href="/" style={{color: '#fff', textDecoration: 'underline'}}> MSB Association</a> . All Rights Reserved. 
          {/* <a href="https://www.calyx-solutions.com/" target='_blank' style={{color: '#ddd', textDecoration: 'underline'}}>Calyx Solutions</a> */}
          </p>
        </div>
        {/* <div className="col-lg-6">
          <ul className="social_icons_block fc_social_icons_block unordered_list justify-content-center justify-content-lg-end">         
            <li><a aria-label="Facebook" href="#!"><i className="fa-brands fa-facebook-f" style={{color: "#111"}} /></a></li>
            <li><a aria-label="Linkedin" href="#!"><i className="fa-brands fa-linkedin-in" style={{color: "#111"}} /></a></li>
            <li><a aria-label="Paper Plane" href="#!"><i className="fa-solid fa-paper-plane" /></a></li>
          </ul>
        </div> */}
      </div>
    </div>
  </div>
  
</footer>


<CookieConsent/>

    </div>
  )
}

export default Footer
